module.exports = __webpack_public_path__ + "static/media/ecografo.a52b6549.jpg";